import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Options from "./Options";
import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Box, Typography } from "@mui/material/";
import backIcon from "../assets/back.svg";
import { getDatabase, ref, push } from "firebase/database";
import firebase from "../firebase";
import buttonSX from './muiStyles/buttonSX.js'

const Questions = ({ userData, setUserData }) => {
  // Counters
  const [questionCounter, setQuestionCounter] = useState(25);
  const [options, setOptions] = useState(0);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (userData.introvertOptions !== "") {
      setUserData((prev) => ({ ...prev, 0: true }));
    }
    if (userData.sportsOptions !== "") {
      setUserData((prev) => ({ ...prev, 1: true }));
    }
    if (
      userData.mentorType === "Mentee" &&
      userData.firstName !== "" &&
      userData.lastName !== "" &&
      userData.email !== "" &&
      userData.pnoun !== "" &&
      userData.country !== "" &&
      userData.timeZone !== ""
      // userData.expertise !== ""
    ) {
      setUserData((prev) => ({ ...prev, 2: true }));
    }
    if (
      userData.mentorType === "Mentor" &&
      userData.firstName !== "" &&
      userData.lastName !== "" &&
      userData.email !== "" &&
      userData.pnoun !== "" &&
      userData.country !== "" &&
      userData.timeZone !== ""
      // userData.expertise !== ""
    ) {
      setUserData((prev) => ({ ...prev, 2: true }));
    }
    if (
      userData.mentorType === "Mentee" &&
      userData.expertise !== "" &&
      userData.goalsOptions !== "" &&
      userData.connectType !== "" &&
      userData.bootcamp !== "" &&
      userData.experienceOptions !== "" &&
      userData.skillsOptions.length !== 0
    ) {
      setUserData((prev) => ({ ...prev, 3: true }));
    } else if (
      userData.mentorType === "Mentor" &&
      userData.image.length !== 0 &&
      userData.bio !== "" &&
      userData.expertise !== "" &&
      userData.company !== "" &&
      userData.goalsOptions !== "" &&
      userData.connectType !== "" &&
      userData.bootcamp !== "" &&
      userData.experienceOptions !== "" &&
      userData.skillsOptions.length !== 0
    ) {
      setUserData((prev) => ({ ...prev, 3: true }));
    }
  }, [toggle]);

  // Handler Functions
  const handleProgress = () => {
    setQuestionCounter((prevProgress) => prevProgress + 25);
    setOptions((prevOption) => prevOption + 1);
  };

  const handleUserChange = (e) => {
    setToggle(!toggle);
    setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onUpload = (imageList, addUpdateIndex) => {
    setToggle(!toggle);
    setUserData((prev) => ({ ...prev, image: imageList }));
    // setImage(imageList);
  };

  const handleBack = () => {
    if (questionCounter === 25) {
      navigate("/questionintro");
    } else {
      setQuestionCounter((prevProgress) => prevProgress - 25);
      setOptions((prevOption) => prevOption - 1);
    }
  };

  console.log(userData.sportsOptions)

  const handleSubmit = () => {
    const database = getDatabase(firebase);
    const dbRef = ref(database);
    // The object of user data we submit to FB
    const userUpload = {
      personality: userData.introvertOptions,
      sports: userData.sportsOptions,
      name: {
        first: userData.firstName,
        last: userData.lastName,
      },
      pronouns: userData.pnoun,
      expertise: userData.expertise,
      mentorType: userData.mentorType,
      skills: userData.skillsOptions,
      expLevel: userData.experienceOptions,
      goals: userData.goalsOptions,
      connectType: userData.connectType,
      bootcamp: userData.bootcamp,
      image: userData.image,
      bio: userData.bio,
      email: userData.email,
      country: userData.country,
      timeZone: userData.timeZone,
      company: userData.company,
    };
    push(dbRef, userUpload);
    setUserData({
      sportsOptions: "",
      introvertOptions: "",
      goalsOptions: "",
      bootcamp: "",
      firstName: "",
      lastName: "",
      expertise: "",
      pnoun: "",
      mentorType: "",
      connectType: "",
      skillsOptions: [],
      experienceOptions: "",
      image: [],
      bio: "",
      email: "",
      country: "",
      timeZone: "",
      company: "",
      0: false,
      1: false,
      2: false,
      3: false,
    });


    if (userData.mentorType === "Mentee") {
      navigate("/matches");
    } else {
      navigate("/success");
    }
  };


  const offSX = {
    backgroundColor: "#808080",
    textTransform: "none",
    pointerEvents: "none",
    "&:hover": {
      backgroundColor: "#131087",
    },
  };

  const navigate = useNavigate();

  return (
    <div className="wrapper">
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ ease: "easeInOut", duration: 1 }}
        className="questions"
      >
        <div className="upper">
          <Box sx={{ position: "relative", display: "inline-flex" }}>
            <CircularProgress
              size={70}
              className="progressBar"
              color="inherit"
              thickness={10}
              value={questionCounter}
              variant="determinate"
            />
            <CircularProgress
              size={70}
              className="progressBarGrey"
              color="inherit"
              thickness={10}
              value={100}
              variant="determinate"
            />

            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="caption" component="div" color="black">{`${
                options + 1
              } / 4`}</Typography>
            </Box>
          </Box>
          <div onClick={handleBack} className="return" variant="contained">
            <img src={backIcon} alt="return back" />
          </div>
        </div>
        <div className="variable">
          <Options
            {...{
              setUserData,
              handleUserChange,
              userData,
              options,
              onUpload,
            }}
          />
        </div>
        <div className="lower">
          {questionCounter === 100 ? (
            <Button
              sx={userData[options] ? buttonSX : offSX}
              onClick={handleSubmit}
              className="button advance"
              variant="contained"
            >
              Submit
            </Button>
          ) : (
            <Button
              sx={userData[options] ? buttonSX : offSX}
              onClick={handleProgress}
              className="button advance"
              variant="contained"
            >
              Next
            </Button>
          )}
        </div>
      </motion.section>
    </div>
  );
};

export default Questions;
